import React, { useEffect, useState } from "react";
import { webFormApiService } from "../../../cores/webForm/services/api";
import { FormInput, WebForm } from "../../../cores/webForm/interfaces/api/get-web-form";
import FormFieldsView from "../forms/web/FormFieldsView";

interface Props {
  companyId?: string;
  formId?: string | null;
}

const blockStyle: React.CSSProperties = {
  padding: 24,
  borderRadius: 12,
  background: "#f8fafc",
  border: "1px solid #e2e8f0",
};

export function ContactFormBlock({ companyId, formId }: Props) {
  const [form, setForm] = useState<WebForm | null>(null);
  const [inputs, setInputs] = useState<FormInput[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!companyId || !formId) {
      setForm(null);
      setInputs([]);
      setError(null);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    webFormApiService
      .getWebForm(companyId, String(formId))
      .then((response) => {
        if (cancelled) return;
        setForm(response.form);
        setInputs(response.inputs);
      })
      .catch(() => {
        if (cancelled) return;
        setForm(null);
        setInputs([]);
        setError("No pudimos cargar la vista previa del formulario.");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [companyId, formId]);

  if (!companyId || !formId) {
    return (
      <div className="wp-contact-form-block" style={blockStyle}>
        <strong>Formulario de contacto Wembii</strong>
        <p style={{ margin: "8px 0 0", color: "#64748b" }}>
          Selecciona un formulario web en los ajustes de la página para mostrarlo aquí.
        </p>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="wp-contact-form-block" style={{ ...blockStyle, color: "#64748b" }}>
        Cargando formulario...
      </div>
    );
  }

  if (error || !form) {
    return (
      <div className="wp-contact-form-block" style={{ ...blockStyle, color: "#b42318" }}>
        {error || "Formulario no disponible."}
      </div>
    );
  }

  return (
    <div className="wp-contact-form-block" style={blockStyle}>
      {!form.isActive && (
        <div
          style={{
            display: "inline-block",
            marginBottom: 12,
            padding: "4px 10px",
            borderRadius: 999,
            background: "#fef3c7",
            color: "#92400e",
            fontSize: 12,
            fontWeight: 600,
          }}
        >
          Inactivo en producción
        </div>
      )}
      <FormFieldsView
        form={form}
        inputs={inputs.map((input) => ({ ...input, value: "" }))}
        readOnly
        className="d-flex flex-column align-items-center p-2"
        innerClassName="w-100 p-3 shadow-sm bg-white rounded"
      />
    </div>
  );
}
